export default __webpack_public_path__ + "static/media/costanera-center.d9a08635.svg";